// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.type === 'light' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontSize: 20,
    lineHeight: '26px',
  },
  text: {
    color: theme.palette.type === 'light' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontSize: 18,
    lineHeight: '27px',
  },
  dialogTitle: {
    padding: 0,
    maxWidth: '60%',
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'inherit',
    },
  },
  dialogContent: {
    flex: 'initial',
    padding: 0,
    maxWidth: '94%',
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'inherit',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-around',
    },
  },
  continueButton: {
    width: 147,
    padding: '7px 27px',
    border: `1px solid ${theme.palette.type === 'light' ? theme.palette.ava.blue2 : theme.palette.ava.blue2}`,
    borderRadius: 100,
    color: theme.palette.type === 'light' ? theme.palette.ava.blue2 : theme.palette.ava.blue2,
    fontSize: 20,
    lineHeight: '26px',
    '&:hover': {
      background: theme.palette.type === 'light' ? theme.palette.ava.navy5 : theme.palette.ava.blue5,
    },
    [theme.breakpoints.down('xs')]: {
      width: 'initial',
      padding: '6px 16px',
    },
  },
  saveButton: {
    width: 148,
    padding: '7px 31px',
    background: theme.palette.ava.blue2,
    borderRadius: 100,
    color: '#FFFFFF',
    fontSize: 20,
    lineHeight: '26px',
    '&:hover': {
      background: theme.palette.ava.blue1,
    },
    [theme.breakpoints.down('xs')]: {
      width: 'initial',
      padding: '6px 34px',
    },
  },
}));

interface Props {
  onContinueClicked: Function;
  onSaveClicked: Function;
}

const SaveTranscriptDialog2 = ({ onContinueClicked, onSaveClicked }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <DialogTitle className={classes.heading} classes={{ root: classes.dialogTitle }}>
        {t('saveTranscript.dialog2.heading')}
      </DialogTitle>
      <DialogContent className={classes.text} classes={{ root: classes.dialogContent }}>
        {t('saveTranscript.dialog2.text')}
      </DialogContent>
      <div className={classes.buttonContainer}>
        <Button className={classes.continueButton} onClick={onContinueClicked}>
          {t('saveTranscript.dialog2.continueButton')}
        </Button>
        <Button className={classes.saveButton} onClick={onSaveClicked}>
          {t('saveTranscript.dialog2.saveButton')}
        </Button>
      </div>
    </>
  );
};

export default SaveTranscriptDialog2;
